import { datadogRum } from '@datadog/browser-rum';
import { getEnvValue } from '@/config/env.ts';

export function initDatadog() {
  datadogRum.init({
    applicationId: '692bdd74-3456-4b13-8248-730db63d5a23',
    clientToken: 'pub322ebe93cb7c9e8193b1cfed8b36e979',
    site: 'datadoghq.com',
    service: 'ixio_webview',
    env: getEnvValue(),
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
    version: import.meta.env.VITE_TAG_NAME || 'unknown',
  });
}
